export default __webpack_public_path__ + "static/media/inprogress-status.3c546781.svg";